import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from '@laboratoria/sdk-react';
import App from './components/App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppProvider App={App} productionHostname="bootcamp.laboratoria.la" />
  </React.StrictMode>
);
